enum StorageKey {

    AccountType = "__act",
    Accounts = "__acts",
    Username = "__usn",
    UserId = "__usdi",
    PortfolioSort = "__ps",
    SymbolsSort = "__ss",
    ShowChart = "__sciq",
    ChartMobileY = "__cmy",
    PopupSound = "__pps",
    Emails = "__pem",
    PushNotifications = "__ppn",
    PhoneCalls = "__ppc",
    SMS = "__psms"
}

namespace StorageKey {

    export function hasKey(key: string): boolean {
        for (const sk in StorageKey) {
            if (StorageKey[sk] === key) {
                return true;
            }
        }
        return false;
    }
}

export {
    StorageKey
};
